/** INR display for subscription charges — always 2 decimal places unless overridden. */
export function formatMoneyInr(value = 0, fractionDigits = 2) {
  const n = Number(value);
  const amount = Number.isFinite(n) ? n : 0;
  return `Rs. ${amount.toLocaleString('en-IN', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}`;
}

/** Round to 2 decimal places for charge math (avoid per-day whole-rupee drift). */
export function roundMoney(value = 0) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}
